import React, { createContext, useState, useEffect } from 'react';
import AuthService from '../services/auth';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(null);

  useEffect(() => {
    const usuarioGuardado = AuthService.getUsuario();
    if (usuarioGuardado) {
      setUsuario(usuarioGuardado);
    }
  }, []);

  const login = async (email, password) => {
    const response = await AuthService.login(email, password);
    setUsuario(response.usuario);
  };

  const logout = () => {
    AuthService.logout();
    setUsuario(null);
  };

  return (
    <AuthContext.Provider value={{ usuario, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};